export const ADD_ERROR = 'add_error'
export const GET_TOP_USER = 'get_top_user'
